export const MODULES = {
  'homepage': {
    roles: ['All'],
    route: {
      path: 'homepage',
      loadChildren: () => import('../app/pages/homepage/homepage.module').then((m) => m.HomepageModule),
      data: { module: 'homepage' }
    },
    menu: {
      name: 'Homepage',
      mat_icon: 'home',
      open: true,
      link: 'homepage',
    }
  },
  'MarketShares': {
    roles: ['MarketShares'],
    route: {
      path: 'market-share',
      loadChildren: () => import('../app/pages/market-share/market-share.module').then(m => m.MarketShareModule),
      data: { module: 'market-share' }
    },
    menu: {
      name: 'Quote di Mercato',
      mat_icon: 'addchart',
      open: false,
      link: 'market-share',
    }
  },
  'Invoices': {
    roles: ['Invoices'],
    route: {
      path: 'invoices',
      data: { module: 'invoices' },
      loadChildren: () => import('../app/pages/invoices/invoices.module').then(m => m.InvoicesModule)
    },
    menu: {
      name: 'Fatture',
      mat_icon: 'receipt_long',
      open: false,
      link: 'invoices'
    }
  },
  'AuditCreation': {
    roles: ['AuditCreation'],
    route: {
      path: 'audit-request',
      data: { module: 'audit-request' },
      loadChildren: () => import('../app/pages/audit-request/audit-request.module').then(m => m.AuditRequestModule)
    },
    menu: {
      name: 'Audit Richieste',
      mat_icon: 'campaign',
      open: false,
      link: 'audit-request'
    }
  },
  'auditManagement': {
    roles: ['AuditManagement'],
    route: {
      path: 'audit-management',
      data: { module: 'audit-management' },
      loadChildren: () => import('../app/pages/audit-management/audit-management.module').then(m => m.AuditManagementModule)
    },
    menu: {
      name: 'Gestione Audit',
      mat_icon: 'rocket_launch',
      open: false,
      link: 'audit-management'
    }
  },
  'AuditComplete': {
    roles: ['AuditReports'],
    route: {
      path: 'audit-complete',
      data: { module: 'audit-complete' },
      loadChildren: () => import('../app/pages/audit-complete/audit-complete.module').then(m => m.AuditCompleteModule)
    },
    menu: {
      name: 'Audit Completate',
      mat_icon: 'task_alt',
      open: false,
      link: 'audit-complete'
    }
  }
};
